/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Pxk_TitleInputs */

const vi_pll_new_pxk_title = /** @type {(inputs: Pll_New_Pxk_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu xuất lô sản phẩm`)
};

/**

* @param {Pll_New_Pxk_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_pxk_title = /** @type {((inputs?: Pll_New_Pxk_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Pxk_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_pxk_title(inputs)
});